export default __webpack_public_path__ + "static/logo-379769ed02197c30e4a2b7f308453d08.svg";